<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <h3 class="margin-b-8">Wil je deze opdracht uitvoeren?</h3>
        <div class="fs-small">Laat ons zo snel als mogelijk weten of je deze opdracht wilt uitvoeren</div>
        <button type="button" class="c-btn c-btn--secondary c-btn--small c-btn--expanded margin-b-8 margin-t-24" @click="accept">Accepteren</button>
        <button type="button" class="c-btn c-btn--primary c-btn--small c-btn--hollow c-btn--expanded no-margin" @click="decline">Weigeren</button>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        request: {
            type: Object,
            required: true
        },
        assignment: {
            type: Object,
            required: true
        }
    },
    methods: {
        accept() {
            this.call('/api/request-detail/' + this.$route.params.id + '/accept/').then( () => {

                this.$store.dispatch('request/changeAssignment', {
                    id: this.assignment.id,
                    geaccepteerd_at: this.$options.filters.datestring(new Date())
                });

                this.$store.dispatch('toasts/success', {title: 'Opdracht accepteren', text: 'Je hebt de opdracht geaccepteerd'});
            }).catch( (e)=> {
                this.$store.dispatch('toasts/alert', {title: 'Opdracht accepteren', text: 'Helaas konden we de opdracht niet accepteren'});
            });
        },

        decline() {
            this.call('/api/request-detail/' + this.$route.params.id + '/decline/').then( () => {
                this.$store.dispatch('request/changeAssignment', {
                    id: this.assignment.id,
                    afgewezen_at: this.$options.filters.datestring(new Date())
                });
                this.$store.dispatch('toasts/success', {title: 'Opdracht weigeren', text: 'Je hebt de opdracht geweigerd'});
            }).catch( (e)=> {
                this.$store.dispatch('toasts/alert', {title: 'Opdracht weigeren', text: 'Helaas konden we de opdracht niet weigeren'});
            });
        },

        call(endpoint, callback) {
            return new Promise( (resolve, reject) => {
                this.$xhr.post(endpoint, {
                    opdracht: this.assignment.id
                }).then(resolve).catch(reject)
            });
        }
    },
    computed: {
        ...mapState({
            translator: state => state.user.data.opdrachtnemer
        })
    }
}
</script>
